import { createAction, props } from '@ngrx/store';
import { CatalogApiResponse } from '../../models/core-apis/catalog-api.interfaces';

enum CatalogActionTypes {
  loadCatalogApi = '[flight-shop book widget] load catalog api',
  loadCatalogApiSuccess = '[flight-shop book widget] load catalog api success',
  loadCatalogApiFailure = '[flight-shop book widget] load catalog api failure'
}

export const LoadCatalogApi = createAction(CatalogActionTypes.loadCatalogApi);

export const LoadCatalogApiSuccess = createAction(
  CatalogActionTypes.loadCatalogApiSuccess,
  props<{ catalogApiData: CatalogApiResponse }>()
);

export const LoadCatalogApiFailure = createAction(
  CatalogActionTypes.loadCatalogApiFailure
);
